import clsx from 'clsx';
import { FIELD_LABEL } from '../../../components/detail/detail-classes';
import { PaymentMethodLogo } from '../../../components/PaymentMethodLogo';
import type { PaymentMethodInfo } from '../../../core/api/http-methods/get-user-transactions';
import type { PaymentMethodDisplay } from '../../../types/payment-method-display';
import { transactionMethodView } from '../../../utils/payment-method-view';

interface TransactionPaymentMethodProps {
  paymentMethod: PaymentMethodInfo | null;
  display?: PaymentMethodDisplay | null;
}

/**
 * The "Payment Method" field of a transaction: a logo tile beside the label and detail line. An AutoDebit
 * charge gets a second row under it naming the bank or DuitNow ID that paid. Renders nothing
 * when the transaction has no payment method.
 */
export const TransactionPaymentMethod = ({
  paymentMethod,
  display
}: TransactionPaymentMethodProps) => {
  const view = transactionMethodView(paymentMethod, display);
  if (!view) return null;

  return (
    <>
      <div className="flex items-center gap-3 py-2">
        {view.logo ? (
          <div className="flex h-10 w-14 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-white px-1">
            <PaymentMethodLogo
              logo={view.logo}
              imgClassName="h-5 object-contain"
              glyphClassName="h-5 w-5 text-gray-400"
            />
          </div>
        ) : null}
        <div className="min-w-0">
          <p className={clsx('mb-1', FIELD_LABEL)}>Payment Method</p>
          <p className="text-sm font-medium text-gray-900">{view.label}</p>
          {view.detail ? (
            <p className="text-xs text-gray-500">{view.detail}</p>
          ) : null}
        </div>
      </div>
      {view.autoDebitRow ? (
        <div className="py-2">
          <p className={clsx('mb-1', FIELD_LABEL)}>
            {view.autoDebitRow.caption}
          </p>
          <p className="text-sm font-medium text-gray-900">
            {view.autoDebitRow.value}
          </p>
        </div>
      ) : null}
    </>
  );
};
